import React from 'react';
import { useRouteMatch } from 'react-router-dom';
import DisciplineDetailView, { DisciplineType } from './DisciplineDetailView';

interface DisciplineDetailPeriodViewProps {
  discipline: DisciplineType;
}

export default function DisciplineDetailPeriodView({ discipline }: DisciplineDetailPeriodViewProps) {
  const { path, url } = useRouteMatch();
  const match = useRouteMatch<{ periodId?: string }>(`${path}/:periodId?`);
  const periodId = match?.params.periodId;

  return (
    <DisciplineDetailView discipline={discipline} urlPeriodId={periodId} url={url} />
  );
}
